import { render, staticRenderFns } from "./PropertiesCounter.vue?vue&type=template&id=7118affe"
import script from "./PropertiesCounter.vue?vue&type=script&lang=js"
export * from "./PropertiesCounter.vue?vue&type=script&lang=js"
import style0 from "./PropertiesCounter.vue?vue&type=style&index=0&id=7118affe&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports